<template>
  <div v-if="$keycloak.hasRealmRole('billadmin') && billTemplate">
    <h1>Bill template</h1>
    <v-btn :to="{ name: 'billTemplates' }">
      <v-icon>chevron_left</v-icon>Bill templates
    </v-btn>
    <p v-if="billTemplate.category">{{ billTemplate.category.name }}</p>
    <template v-if="!editHeader">
      {{ billTemplate.name }}&#160;
      <a @click="editHeader = true">Change</a>
    </template>
    <div class="ajaxForm" v-if="editHeader">
      <v-text-field label="Name" v-model="template.name" />
      <v-checkbox label="Archived" v-model="template.archived" />
      <v-btn @click="updateHeader"> <v-icon>save</v-icon>Save </v-btn>
      <v-btn @click="editHeader = false"> <v-icon>undo</v-icon>Cancel </v-btn>
    </div>
    <p v-if="billTemplate.archived">
      Bill is archived. Unarchive to edit entries
    </p>
    <div v-if="!billTemplate.archived">
      <div
        v-for="billTemplateMoney in billTemplate.templateMonies"
        :key="billTemplateMoney.id"
      >
        <div style="margin-top: 10px">
          <strong>{{ billTemplateMoney.name }}</strong
          >&#160;
          <a @click="createBillTemplateSection(billTemplateMoney)"
            >Add section</a
          >
        </div>
        <div style="margin-left: 15px">
          <div
            v-for="billTemplateSection in billTemplateMoney.templateSections"
            :key="billTemplateSection.id"
          >
            <div
              style="margin: 10px 0px 5px 0px"
              v-if="!section || billTemplateSection.id != section.id"
              :class="
                billTemplateSection.archived ? 'billTemplateEntryArchived' : ''
              "
            >
              <strong>{{ billTemplateSection.name }}</strong
              >&#160;
              <a
                @click="
                  createBillTemplateEntry(
                    billTemplateMoney,
                    billTemplateSection
                  )
                "
                v-if="!billTemplateSection.archived"
                >Add entry</a
              >&#160;
              <a
                @click="
                  editBillTemplateSection(
                    billTemplateMoney,
                    billTemplateSection
                  )
                "
                >Edit</a
              >
            </div>
            <div
              class="ajaxForm"
              v-if="section && billTemplateSection.id == section.id"
            >
              <v-text-field label="Name" v-model="section.name" />
              <v-checkbox label="Vat" v-model="section.vat" />
              <v-select
                label="Breakdown"
                v-model="section.breakdownid"
                :items="breakdownSections"
                item-value="id"
                item-text="name"
              />
              <v-checkbox label="No subtotal" v-model="section.nosubtotal" />
              <v-text-field label="Label" v-model="section.label" />
              <v-checkbox label="Archived" v-model="section.archived" />
              <v-btn
                @click="
                  updateBillTemplateSection(
                    billTemplateMoney,
                    billTemplateSection
                  )
                "
              >
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn @click="section = null">
                <v-icon>undo</v-icon>Cancel
              </v-btn>
            </div>
            <div style="margin-left: 15px" v-if="!billTemplateSection.archived">
              <div
                v-for="billTemplateEntry in billTemplateSection.templateEntries"
                :key="billTemplateEntry.id"
              >
                <div
                  :class="
                    billTemplateEntry.archived
                      ? 'billTemplateEntryArchived'
                      : ''
                  "
                  v-if="!entry || billTemplateEntry.id != entry.id"
                >
                  <span
                    class="billTemplateAdd"
                    v-if="billTemplateEntry.entrytype == 'add'"
                    >ADD</span
                  >
                  <span
                    class="billTemplateLess"
                    v-if="billTemplateEntry.entrytype == 'less'"
                    >LESS</span
                  >
                  {{ billTemplateEntry.name }}
                  <span
                    class="billTemplateEntryCount"
                    v-if="billTemplateEntry.entryCount !== undefined"
                    >({{ billTemplateEntry.entryCount }})</span
                  >&#160;
                  <span
                    class="salesDescription"
                    v-if="billTemplateEntry.description"
                  >
                    <span>{{ billTemplateEntry.description.body }}</span> </span
                  >&#160;
                  <span
                    class="salesDescription"
                    v-if="billTemplateEntry.discount"
                    >{{ billTemplateEntry.discount }}</span
                  >&#160;
                  <span
                    class="includedByDefault"
                    v-if="billTemplateEntry.includedByDefault"
                    >Included by default</span
                  >&#160;
                  <a
                    v-if="billTemplateEntry.up"
                    @click="
                      moveBillTemplateEntry(
                        billTemplateMoney,
                        billTemplateSection,
                        billTemplateEntry,
                        false
                      )
                    "
                    >Up</a
                  >&#160;
                  <a
                    v-if="billTemplateEntry.down"
                    @click="
                      moveBillTemplateEntry(
                        billTemplateMoney,
                        billTemplateSection,
                        billTemplateEntry,
                        true
                      )
                    "
                    >Down</a
                  >&#160;
                  <a @click="editBillTemplateEntry(billTemplateEntry)">Edit</a>
                </div>
                <div
                  class="ajaxForm"
                  v-if="entry && billTemplateEntry.id == entry.id"
                >
                  <v-text-field
                    label="Bt entry id"
                    v-model="entry.id"
                    :readonly="true"
                  />
                  <v-text-field
                    label="Name"
                    v-model="entry.name"
                    :readonly="billTemplateEntry.entryCount > 0"
                  />
                  <v-text-field
                    label="Default value"
                    v-model.number="entry.value"
                  />
                  <v-select
                    label="Entry type"
                    v-model="entry.entrytype"
                    :items="entryTypes"
                    item-value="id"
                    item-text="name"
                    v-if="billTemplateEntry.entryCount === 0"
                  />
                  <v-text-field
                    label="Entry type"
                    v-model="entry.entrytype"
                    :readonly="true"
                    v-if="billTemplateEntry.entryCount > 0"
                  />
                  <v-checkbox label="Archived" v-model="entry.archived" />
                  <v-checkbox
                    label="Included by default"
                    v-model="entry.includedByDefault"
                  />
                  <v-select
                    label="sales entry"
                    v-model="entry.descriptionid"
                    :items="descriptions"
                    item-value="id"
                    item-text="body"
                  >
                    <template slot="append-outer" v-if="entry.descriptionid">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a @click="entry.descriptionid = null" v-on="on">
                            <v-icon>clear</v-icon>
                          </a>
                        </template>
                        <span>Clear description</span>
                      </v-tooltip>
                    </template>
                  </v-select>
                  {{ entry.descriptionid }}
                  <v-select
                    label="Sales discount"
                    v-model="entry.discount"
                    :items="discounts"
                    item-value="id"
                    item-text="name"
                  >
                    <template slot="append-outer" v-if="entry.discount">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a @click="entry.discount = null" v-on="on">
                            <v-icon>clear</v-icon>
                          </a>
                        </template>
                        <span>Clear discount</span>
                      </v-tooltip>
                    </template>
                  </v-select>
                  <v-text-field
                    label="Times used"
                    v-model="entry.entryCount"
                    :readonly="true"
                  />
                  <v-btn
                    @click="
                      updateBillTemplateEntry(
                        billTemplateMoney,
                        billTemplateSection,
                        billTemplateEntry
                      )
                    "
                  >
                    <v-icon>save</v-icon>Save
                  </v-btn>
                  <v-btn @click="entry = null">
                    <v-icon>undo</v-icon>Cancel
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BILL_TEMPLATE from "@/graphql/accounts/billTemplate/BillTemplate";
import CREATE_BILL_TEMPLATE_ENTRY from "@/graphql/accounts/billTemplate/CreateBillTemplateEntry";
import CREATE_BILL_TEMPLATE_SECTION from "@/graphql/accounts/billTemplate/CreateBillTemplateSection";
import UPDATE_BILL_TEMPLATE_ENTRY from "@/graphql/accounts/billTemplate/UpdateBillTemplateEntry";
import UPDATE_BILL_TEMPLATE_SECTION from "@/graphql/accounts/billTemplate/UpdateBillTemplateSection";
import DESCRIPTIONS_SALES from "@/graphql/sales/DescriptionsSales";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "BillTemplate",
  metaInfo() {
    return {
      title: "Bill template",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    billTemplate: {
      query: BILL_TEMPLATE,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      fetchPolicy: "cache-and-network"
    },
    descriptions: {
      query: DESCRIPTIONS_SALES,
      update: (data) => data.descriptionsSales,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      // descriptions: [],
      editHeader: false,
      template: null,
      section: null,
      entry: null,
      entryTypes: [
        {
          id: "normal",
          name: "NORMAL"
        },
        {
          id: "add",
          name: "ADD"
        },
        {
          id: "less",
          name: "LESS"
        }
      ],
      discounts: [
        {
          id: "discount",
          name: "Online discount"
        },
        {
          id: "spdiscount",
          name: "Sale and purchase discount"
        }
      ],
      breakdownSections: []
    };
  },
  methods: {
    updateHeader() {},
    async createBillTemplateSection(billTemplateMoney) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: CREATE_BILL_TEMPLATE_SECTION,
          variables: {
            id: Number(this.$route.params.id),
            moneyid: billTemplateMoney.id
          },
          refetchQueries: [
            {
              query: BILL_TEMPLATE,
              variables: { id: Number(this.$route.params.id) }
            }
          ]
        });
      }
    },
    async createBillTemplateEntry(billTemplateMoney, billTemplateSection) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: CREATE_BILL_TEMPLATE_ENTRY,
          variables: {
            id: Number(this.$route.params.id),
            moneyid: billTemplateMoney.id,
            sectionid: billTemplateSection.id
          },
          refetchQueries: [
            {
              query: BILL_TEMPLATE,
              variables: { id: Number(this.$route.params.id) }
            }
          ]
        });
      }
    },
    async moveBillTemplateEntry(
      billTemplateMoney,
      billTemplateSection,
      billTemplateEntry,
      down
    ) {
      await nbmlaw.put(
        `/cors/admin/bill/templates/${this.$route.params.id}/monies/${billTemplateMoney.id}/sections/${billTemplateSection.id}/entries/${billTemplateEntry.id}/move/${down}`,
        null
      );
      // console.log(response.data)
      this.update();
    },
    editBillTemplateSection(billTemplateMoney, billTemplateSection) {
      this.section = JSON.parse(JSON.stringify(billTemplateSection));
      this.entry = null;
      this.breakdownSections = billTemplateMoney.templateSections.map(
        (templateSection) => {
          return {
            id: templateSection.id,
            name: templateSection.name
          };
        }
      );
    },
    editBillTemplateEntry(billTemplateEntry) {
      this.section = null;
      this.entry = JSON.parse(JSON.stringify(billTemplateEntry));
      this.entry.descriptionid = billTemplateEntry.description
        ? billTemplateEntry.description.id
        : undefined;
    },
    async updateBillTemplateSection(billTemplateMoney, billTemplateSection) {
      await this.$apollo.mutate({
        mutation: UPDATE_BILL_TEMPLATE_SECTION,
        variables: {
          id: Number(this.$route.params.id),
          moneyid: billTemplateMoney.id,
          sectionid: billTemplateSection.id,
          jo: this.section
        },
        refetchQueries: [
          {
            query: BILL_TEMPLATE,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.section = null;
    },
    async updateBillTemplateEntry(
      billTemplateMoney,
      billTemplateSection,
      billTemplateEntry
    ) {
      await this.$apollo.mutate({
        mutation: UPDATE_BILL_TEMPLATE_ENTRY,
        variables: {
          id: Number(this.$route.params.id),
          moneyid: billTemplateMoney.id,
          sectionid: billTemplateSection.id,
          entryid: billTemplateEntry.id,
          jo: this.entry
        },
        refetchQueries: [
          {
            query: BILL_TEMPLATE,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.entry = null;
    },
    descriptionBody(billTemplateEntry) {
      const description = this.descriptions.find((d) => {
        return d.id == billTemplateEntry.id;
      });
      if (description) {
        return description.body;
      }
      return null;
    },
    update() {}
  },
  watch: {
    billTemplate: {
      immediate: true,
      handler() {
        if (this.billTemplate) {
          this.template = {
            id: this.billTemplate.id,
            name: this.billTemplate.name,
            archived: this.billTemplate.archived
          };
        }
      }
    }
  }
};
</script>

<style>
.salesDescription {
  background: gray;
  color: white;
}

.billTemplateEntryArchived {
  text-decoration: line-through;
  font-size: 0.7em;
}

.billTemplateEntryCount {
  color: gray;
}

.billTemplateEntrySecondary {
  font-size: 0.8em;
}

.billTemplateAdd {
  color: green;
}

.billTemplateLess {
  color: red;
}

.includedByDefault {
  color: green;
}
</style>
